// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3f3050a0","732":"5f47aa28"}[chunkId] + ".chunk.js";
};